export default {"src":"/_next/static/media/llink.7a93e2c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};